import React from 'react';
import { SearchResultCommentary } from './SearchResultCommentary';
import { SearchComment } from './searchResultComment.types';
import { Connect, PropsFromRedux } from './SearchResultCommentariesContainer';
import { ItemSeparator } from '../../../../components/item-separator/ItemSeparator';

type Props = {
  commentaries: Array<SearchComment>;
} & PropsFromRedux;

class RawSearchResultCommentaries extends React.Component<Props> {
  render() {
    const { commentaries, originalQueryKey } = this.props;
    return (
      <>
        {commentaries.map((comment, index) => (
          <div
            data-test-id="search-commentary-card"
            className="excerpt_comment"
            key={comment.commentaireId}
          >
            <ItemSeparator />
            <SearchResultCommentary
              comment={comment}
              index={index}
              originalQueryKey={originalQueryKey || ''}
            />
          </div>
        ))}
      </>
    );
  }
}

export const SearchResultCommentaries = Connect(RawSearchResultCommentaries);
